import { defineStore } from 'pinia';
import type { GameSchema } from '@cmp/game-mechanics';
import { requests } from '@/common/plugins/axios';

interface IGameResponse {
  id: number;
  name: string;
  description: string;
  thumbnailUrl: string;
  mechanic: {
    folderName: string;
  };
  settings: {
    properties: Record<string, string | number | boolean>;
    config: Record<string, string | number | boolean>;
    children: [];
  }
}

export interface AssetDialogConfig {
  onOk?: (item: IGameResponse) => void;
  onCancel?: () => void;
}

export const useGamesStore = defineStore('games', {
  state: () => ({
    games: [] as IGameResponse[],
    selectedGameSchema: {} as Partial<GameSchema>,
    selectedGameId: null,
    selectedGamePath: '',
    dialogSettings: {} as AssetDialogConfig,
    showDialog: false,
  }),

  getters: {
    getGame: (state) => {
      if (!state.selectedGameId) return '';
      return state.games.find((n) => n.id === state.selectedGameId);
    },
    getAllGames: (state) => state.games,
    defaultGameSettings: (state) => Object.entries(state.selectedGameSchema.properties || {})
      .reduce((prev, [k, n]) => {
        const clone = { ...prev };
        clone[k] = n.default;
        return clone;
      }, {}),
  },

  actions: {
    async getGames(): Promise<void> {
      const result = await requests.get('/types/games', {
        id: 'fetch-games',
      });

      this.games = result.items;
    },

    showGamesDialog(options: AssetDialogConfig): void {
      this.showDialog = true;
      this.dialogSettings = options;
    },

    hideGamesDialog() {
      this.dialogSettings = {};
      this.showDialog = false;
    },
  },
});

export default useGamesStore;
